var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_29324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0999 9.53164C19.0999 15.8316 10.9999 21.2316 10.9999 21.2316C10.9999 21.2316 2.8999 15.8316 2.8999 9.53164C2.8999 7.38339 3.75329 5.32312 5.27234 3.80408C6.79138 2.28503 8.85165 1.43164 10.9999 1.43164C13.1482 1.43164 15.2084 2.28503 16.7275 3.80408C18.2465 5.32312 19.0999 7.38339 19.0999 9.53164Z",
    stroke: "#AAABAE",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12.2313C12.4912 12.2313 13.7 11.0224 13.7 9.53125C13.7 8.04008 12.4912 6.83125 11 6.83125C9.50888 6.83125 8.30005 8.04008 8.30005 9.53125C8.30005 11.0224 9.50888 12.2313 11 12.2313Z",
    stroke: "#AAABAE",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_29324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(0.199951 0.53125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.490da2f18f44f4fd6feb4bf73465bbad.svg";
export { ForwardRef as ReactComponent };